import { Dispatch, SetStateAction } from 'react';
import { IoIosCloseCircleOutline } from 'react-icons/io';

interface ModalProps {
    isOpen: boolean;
    onRequestClose: Dispatch<SetStateAction<boolean>>;
    children: React.ReactNode;
}

const Modal = ({ isOpen, onRequestClose, children }: ModalProps) => {
    const handleCloseClick = () => {
        onRequestClose(false);
    };
    return (
        isOpen && (
            <div
                className="z-20 inset-0 fixed overflow-y-hidden flex items-center justify-center bg-black bg-opacity-75 backdrop-blur-sm"
                onClick={handleCloseClick}
            >
                <div className="w-[90%] max-h-[90%] sm:w-auto h-auto pt-8 p-4 mx-2 bg-white border border-green-500 absolute overflow-y-auto">
                    {children}
                    <button
                        className="absolute top-2 right-2"
                        onClick={handleCloseClick}
                    >
                        <IoIosCloseCircleOutline size={28} title="Close" />
                    </button>
                </div>
            </div>
        )
    );
};

export default Modal;
